import * as React from "react";
import { connect } from "react-redux";

import {
  BackToHousehold,
  DisclosureModal,
  PortfolioHistoryModal,
  SubNav,
} from "..";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  bottomLink: {
    background: "transparent",
    color: theme.palette.grey[600],
    cursor: "pointer",
    fontSize: 14,
    height: "auto",
    position: "absolute",
    top: "auto",
    left: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      paddingLeft: 25,
      bottom: 13,
    },
    [theme.breakpoints.down("lg")]: {
      left: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: 13
    },
    "&.disclosure": {
      bottom: 40,
    },
    "&.history": {
      bottom: 80,
    },
  },
});

function PortfolioNavigation({
  app,
  pathname,
  open,
  currentPortfolio,
  classes,
}) {
  const { currentStep } = app;
  const portfolioId = currentPortfolio && currentPortfolio.uuid;
  const householdId = currentPortfolio && currentPortfolio.Household.id;
  const predecessorPortfolioId =
    currentPortfolio && currentPortfolio.predecessorPortfolioId;
  const successorPortfolioId =
    currentPortfolio && currentPortfolio.successorPortfolioId;

  return (
    <SubNav
      items={[
        {
          isActive: currentStep === 4,
          isAvailable: householdId && currentStep >= 4,
          label: "Portfolio",
          path: `/Portal/household/${householdId}/portfolio/${portfolioId || ""}`,
        },
        {
          isActive: currentStep === 5,
          isAvailable: householdId && currentStep >= 5,
          label: "Summary",
          path: `/Portal/household/${householdId}/summary/${portfolioId || ""}`,
        },
      ]}
      open={open}
      pathname={pathname}
      suffix={
        <React.Fragment>
          {(predecessorPortfolioId || successorPortfolioId) && (
            <PortfolioHistoryModal
              dialogAnchorComponent={
                <span className={`${classes.bottomLink} history`}>HISTORY</span>
              }
              portfolioId={portfolioId}
              householdId={householdId}
            />
          )}
          <DisclosureModal
            dialogAnchorComponent={
              <span className={`${classes.bottomLink} disclosure`}>
                DISCLOSURES
              </span>
            }
          />
          <BackToHousehold householdId={householdId} />
        </React.Fragment>
      }
    />
  );
}

const mapStateToProps = (state, props) => {
  return {
    app: state.app,
    currentPortfolio: state.portfolio.currentPortfolio,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(PortfolioNavigation)
);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/PortfolioNavigation/index.jsx